import { Translation } from '@ps/web-shared-components';
import React from 'react';

import Container from '../../../Container/Container';
import RMFCrossOperatorDepositLimitFields from '../RMFCrossOperatorDepositLimit/components/RMFCrossOperatorDepositLimitFields';
import UniqueIdPrompt from '../RMFUniqueIdPrompt/RMFUniqueIdPrompt';

import {
  TXTCLI_Cross_Operator_Deposit_Limit,
  TXTWCL_Responsible_Gaming_Limits,
  TXTWCL_This_is_a_monthly_limit_on_dep_ELL
} from './RMFResult.messages.json';

const RMFResult: React.FC = () => (
  <Container
    page={RMFResult}
    headerProps={{
      title: <Translation {...TXTWCL_Responsible_Gaming_Limits} />,
      buttons: {}
    }}
    pageTopTitle={<Translation {...TXTCLI_Cross_Operator_Deposit_Limit} />}
    pageTopSubtitle={<Translation {...TXTWCL_This_is_a_monthly_limit_on_dep_ELL} />}
  >
    <RMFCrossOperatorDepositLimitFields />
    <UniqueIdPrompt />
  </Container>
);

RMFResult.displayName = 'RMFResult';

export default RMFResult;
